/** Partner Management permission keys from GET /permission/get/:role_id (permissions.permission_key). */
export const PARTNER_MANAGEMENT_PERMISSION_KEYS = {
  /** Partner list advanced filter control only (sliders icon / filter modal). */
  PARTNER_LIST_FILTER: "partner_list_filter",
  /** Partner Details tab and partner profile edit/create. */
  PARTNER_CONFIGURATIONS: "partner_configurations",
  PARTNER_REPORTS_EXPORT: "partner_reports_export",
  MANAGE_PARTNER_USER: "manage_partner_user",
  CONTRACT_MANAGEMENT: "contract_management",
  ADMIN_ORDER_MANAGEMENT: "admin_order_management",
  ADMIN_PROJECT_MANAGEMENT: "admin_project_management",
  PARTNER_NOTES: "partner_notes",
  ACTIVITY_LOG: "activity_log",
  ADMIN_PARTNER_PROGRAM: "admin_partner_program",
  ACCESS_PARTNER_VIEW: "access_partner_view",
  /** Partner Organizations → Integration Status tab and its toolbar actions. */
  ADMIN_PARTNER_INTEGRATION_STATUS: "admin_partner_integration_status",
  /** Partner Organizations → Benefit Activity Log tab and its toolbar actions. */
  BENEFIT_ACTIVITY_LOG: "benefit_activity_log",
  /** Manage-partner Dashboard tab and support status editing. */
  PARTNER_ADMIN_DASHBOARD: "partner_admin_dashboard",
} as const;

export type PartnerManagementPermissionKey =
  (typeof PARTNER_MANAGEMENT_PERMISSION_KEYS)[keyof typeof PARTNER_MANAGEMENT_PERMISSION_KEYS];

/**
 * Inside manage-partner sub-modules (sidebar tabs + Access Partner View).
 * Excludes list-only keys: partner_list_filter, partner_reports_export,
 * admin_partner_integration_status, benefit_activity_log.
 */
export const PARTNER_MANAGE_PARTNER_SUBMENU_KEYS: PartnerManagementPermissionKey[] = (
  Object.values(PARTNER_MANAGEMENT_PERMISSION_KEYS) as PartnerManagementPermissionKey[]
).filter(
  (key) =>
    key !== PARTNER_MANAGEMENT_PERMISSION_KEYS.PARTNER_LIST_FILTER &&
    key !== PARTNER_MANAGEMENT_PERMISSION_KEYS.PARTNER_REPORTS_EXPORT &&
    key !== PARTNER_MANAGEMENT_PERMISSION_KEYS.ADMIN_PARTNER_INTEGRATION_STATUS &&
    key !== PARTNER_MANAGEMENT_PERMISSION_KEYS.BENEFIT_ACTIVITY_LOG
);

/** Manage-partner shell route: requires at least one submenu key (edit or view). */
export const PARTNER_ORGANIZATION_ACCESS_KEYS = PARTNER_MANAGE_PARTNER_SUBMENU_KEYS;
